module.exports = __webpack_public_path__ + "static/media/payingguest.e1aa4ecc.jpg";